<template>
  <div v-if="show" class="modal fade show custom-modal-backdrop" aria-modal="true" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between px-1 my-1 align-items-center">
              <h1 class="mb-0">Completion</h1>
              <div class="d-flex align-items-center gap-2">
                <button
                    @click="onCancel"
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                ></button>
              </div>
            </div>
          </div>
        </div>
        <hr class="mt-0">
        <div class="modal-body pt-0">
          <div class="text-center mb-3">
            <p class="text-dark">Are you sure you want to mark <strong>{{ item.name }}</strong> as completed?</p>
          </div>
          
          <div class="form-group text-start">
            <label class="form-label fw-bold small text-uppercase text-dark">Completion Note</label>
            <textarea 
              class="form-control" 
              rows="3" 
              v-model="completionNote" 
              placeholder="Enter completion details..."
            ></textarea>
          </div>
        </div>
        <div class="modal-footer pt-0 border-top-0">
          <button type="button" class="btn btn-secondary" @click="onCancel">Cancel</button>
          <button type="button" class="btn btn-primary" :disabled="loading" @click="onSave">
            <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
            Save & Mark Done
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch } from 'vue';
import handleProjects from "@/services/modules/procurement/project";
import { useToast } from "vue-toastification";

const props = defineProps({
  show: Boolean,
  item: Object
});

const emit = defineEmits(['update:show', 'success']);
const { updateProjectAccountCompletion } = handleProjects();
const toast = useToast();

const completionNote = ref('');
const loading = ref(false);

const onCancel = () => {
  completionNote.value = '';
  emit('update:show', false);
};

const onSave = async () => {
  if (loading.value) return;
  
  loading.value = true;
  try {
    const response = await updateProjectAccountCompletion(props.item.id, {
      project_account_id: props.item.project_account_id,
      project_id: props.item.project_id,
      company_id: props.item.company_id,
      completion_note: completionNote.value
    }, '');

    if (response.status) {
      toast.success(response.message || "Marked as completed!");
      emit('success', completionNote.value);
      onCancel();
    } else {
      toast.error(response.message || "Failed to update completion status.");
    }
  } catch (error) {
    toast.error("An error occurred while updating completion status.");
    console.error(error);
  } finally {
    loading.value = false;
  }
};

watch(() => props.show, (newVal) => {
  if (newVal) {
    completionNote.value = props.item.completion_note || '';
  }
});
</script>

<style scoped>
.custom-modal-backdrop {
  display: block;
  background-color: rgba(28, 29, 28, 0.2);
  z-index: 1060;
}

.modal-content {
  border-radius: 0.358rem;
}

h1 {
  font-size: 1.25rem;
}

.form-control {
  resize: none;
}
</style>
